import {
  EXCLUDED_FROM_DATA_EXTRACTION_DOCUMENT_CATEGORY,
  INACTIVE_DOCUMENT_CATEGORY,
} from 'constants/documentCategories';

export const normalizeDocumentCategory = ({ id, name, orderNumber, types }) => ({
  documentCategoryId: id,
  documentCategoryName: name,
  orderNumber,
  isSystemCategory: false,
  documentTypeIds: types?.map(({ id }) => id),
});

export const normalizeDocumentCategoriesWithSystemCategories = ({
  documentCategories,
  excludedDocumentTypesIds,
  inactiveDocumentTypeIds,
}) => {
  const excludedCategory = {
    ...EXCLUDED_FROM_DATA_EXTRACTION_DOCUMENT_CATEGORY,
    documentTypeIds: excludedDocumentTypesIds,
  };
  const inactiveCategory = {
    ...INACTIVE_DOCUMENT_CATEGORY,
    documentTypeIds: inactiveDocumentTypeIds,
  };

  const categoriesWithDocumentTypeIds = documentCategories.map(normalizeDocumentCategory);

  return [...categoriesWithDocumentTypeIds, excludedCategory, inactiveCategory];
};
